import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { HistoryLayout } from "../../../../common/history/history-layout.component";
import { TablePagination } from '../../../../common/details-table/table-pagination.component';
import { rechargingHistoryActions } from "../../../../../store/external/recharge-reducer/history/recharging-inventory-history-reducer";
import { MODAL_CUSTOM_MESSAGE } from "../../../../../constants/external-constants";

class RechargingHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enableSearchBox: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
        }

    }

    componentWillUnmount() {
        this.props.resetRechargingHistory()
    }

    componentDidMount() {
        this.props.getRechargingHistoryLogs(this.props.rechargeInventoryId)
    }

    onColumnSearch = () => {
        const { getRechargingHistoryLogs, rechargeInventoryId } = this.props;
        getRechargingHistoryLogs(rechargeInventoryId, 0)
    }

    rechargingPaginationAction = (pageIndex) => {
        const { getRechargingHistoryLogs, rechargeInventoryId } = this.props;
        getRechargingHistoryLogs(rechargeInventoryId, pageIndex);
    }

    resizePage = (pageSize) => {
        const { resizeRechargingHistoryLogs, getRechargingHistoryLogs, rechargeInventoryId } = this.props;
        resizeRechargingHistoryLogs(pageSize)
        getRechargingHistoryLogs(rechargeInventoryId);
    }

    displaySearchBox = (value) => {
        this.setState({ enableSearchBox: value })
    }

    onClickExtract = () => {
        const { rechargeInventoryId, rechargingInventoryTypeId, extractRechargingHistoryLogs } = this.props;
        if (window.confirm(this.state.exportAlertMsg)) {
            extractRechargingHistoryLogs(rechargeInventoryId, rechargingInventoryTypeId);
        }
    }  

    render() {
        const { setRechargingHistoryColSearchStr, isReadOnly, isReadAndExtractOnly, isReadAndWrite } = this.props;
        const { IsLoadingTable } = this.props.rechargingHistory;
        const { Headers, Data, Pagination } = this.props.rechargingHistory.HistoryTable;
        return (
            <div>
                <HistoryLayout
                    displaySearchBox={this.displaySearchBox}
                    extractAction={this.onClickExtract}

                    //Access Type
                    isReadOnly={isReadOnly}
                    isReadAndExtractOnly={isReadAndExtractOnly}
                    isReadAndWrite={isReadAndWrite}
                    hideCustomColumn={true}
                >
                    <TablePagination
                        key="table-pagination-key"
                        columns={Headers}
                        pageList={Data}
                        pages={Pagination}
                        paginationAction={this.rechargingPaginationAction}
                        onColumnSearch={this.onColumnSearch}
                        onColumnSearchChange={setRechargingHistoryColSearchStr}
                        isColSearchShow={this.state.enableSearchBox}
                        resizePage={this.resizePage}
                        totalPage={Pagination?.TotalEntries}
                        isLoading={IsLoadingTable}
                        hideStatusIcon={true}
                        isNotSortable={true}
                    />
                </HistoryLayout>
            </div>
        );
    }
}

export default connect(
    state => {
        const { rechargingHistory } = state;
        return {
            rechargingHistory
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, rechargingHistoryActions),
        dispatch
    )
)(RechargingHistory);